import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("UI error:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const ar = document.documentElement.lang === "ar";
    return (
      <div data-testid="error-boundary" role="alert" className="container-lux flex min-h-[50vh] flex-col items-center justify-center gap-4 py-24 text-center">
        <p className="eyebrow">{ar ? "خطأ غير متوقع" : "Unexpected error"}</p>
        <h1 className="h-display text-3xl">{ar ? "تعذّر عرض هذا القسم" : "This section couldn't be displayed"}</h1>
        <div className="flex gap-3">
          <button type="button" className="btn-cta" data-testid="error-boundary-retry" onClick={() => this.setState({ error: null })}>{ar ? "إعادة المحاولة" : "Try again"}</button>
          <a href="/" className="btn-ghost" data-testid="error-boundary-home">{ar ? "الصفحة الرئيسية" : "Home"}</a>
        </div>
      </div>
    );
  }
}
